module.exports = __webpack_public_path__ + "img/logo.2d386c38.png";